import { domainEvent } from "@lookiero/messaging";
const NOTIFICATION_CREATED = "notification_created";
const notificationCreated = ({ aggregateId }) => domainEvent({ aggregateId, name: NOTIFICATION_CREATED });
const isNotificationCreated = (event) => event.name === NOTIFICATION_CREATED;
export { NOTIFICATION_CREATED, notificationCreated, isNotificationCreated };
